import React from 'react';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TextInput from 'screens/components/basic/TextInput';

export default function BranchEmailTable({ reportAutomationInfo, handleCellClick, handleUpdateButtonClick, handleDeleteButtonClick, setTableRef, editingRow, editingColumn }) {
  return (
    <section className="automation-table-section" ref={setTableRef}>
      <Table showRowHover={false} selectable={false} onCellClick={handleCellClick}>
        <TableHead displaySelectAll={false} adjustForCheckbox={false} className="automation-table-header">
          <TableRow>
            <TableCell className="automation-header-column">Branch Name</TableCell>
            <TableCell className="automation-header-column">Email</TableCell>
            <TableCell className="automation-header-column">Edit / Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody displayRowCheckbox={false}>
          {reportAutomationInfo.map((info, index) => (
            <TableRow key={index}>
              <TableCell className="automation-row-column">{info.reportBranch}</TableCell>
              <TableCell className="automation-row-column">
                {editingRow === index && editingColumn === 2
                  ? <TextInput
                    name={`reportAutomationNewEmailInput`}
                    hintText="Enter Your New Email Here"
                    type="email"
                    maxLength={50}
                    floatingLabelStyle={{ fontSize: '12px' }}
                    hintStyle={{ fontSize: '12px' }}
                  />
                  : info.email
                }
              </TableCell>
              <TableCell className="automation-row-column">
                <div className="automation-actions-container">
                  <IconButton className="automation-update-button" onClick={() => handleUpdateButtonClick(info.id, info.reportBranch, info.email, info.ids)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton className="automation-delete-button" onClick={() => handleDeleteButtonClick(info.id, info.reportBranch, info.email, info.ids)}>
                    <DeleteIcon />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </section>
  );
}
